module.exports = __webpack_public_path__ + "img/couples-021.02734f5e.jpg";